import React from 'react';

type SpaceProps = {
  classes: string;
};

const SpaceY: React.FC<SpaceProps> = ({classes}) => <div className={classes} />;

export default SpaceY;
